import painel from './painel/routes';
import { routes as ncostatus } from './nco-status';
import { routes as ncoclassificacao } from './nco-classificacao';
import { routes as ncoacaotipo } from './nco-acao-tipo';
import { routes as nconaoconformidadetipo } from './nco-nao-conformidade-tipo';
import { routes as proximasAcoes } from './proximas-acoes';

export default [
  {
    path: '/nao-conformidade',
    // Sem name de propósito: o painel é o filho de path vazio deste nó, e o vue-router avisa
    // quando uma rota nomeada tem filho de path vazio, porque navegar pelo nome do pai não
    // renderiza nada. O nome não era referenciado em lugar nenhum.
    description: 'Não Conformidade',
    icon: 'uil-betoneira',
    children: [
      // O painel e a tela de ação ficam soltos no primeiro nível do menu; os cadastros vão
      // agrupados em "Configuração", que é o customChildren abaixo.
      ...painel,
      {
        path: 'configuracao',
        description: 'Configuração',
        goesToMenu: false,
        children: [...ncostatus, ...ncoclassificacao, ...ncoacaotipo, ...nconaoconformidadetipo, ...proximasAcoes]
      }
    ],
    customChildren: ['Configuração']
  }
];
